module.exports = __webpack_public_path__ + "img/clear-light.9069f8aa.png";